import * as actionTypes from './constants';

const initialState = {
    physicalConnections: {
        data: null,
        loadingStatus: null,
        error: null
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_PHYSICAL_CONNECTIONS:
            return {
                ...state,
                physicalConnections: { ...state.physicalConnections, ...action }
            };
        case actionTypes.CLEAR_PHYSICAL_CONNECTIONS:
            return {
                ...state,
                physicalConnections: initialState.physicalConnections
            };
        default:
            return state;
    }
}
